import { FC, ReactElement } from 'react'

import { Timer } from '@/containers'
import { useTypedSelector } from '@/store'
import { UserStatus } from '@/types/userStatus'

export const ConnectedTimer: FC = (): ReactElement => {
    const isOnline = useTypedSelector(state => state.appReducer.isOnline)
    const employeeNumber = useTypedSelector(state => state.userReducer.employeeNumber)
    const pin = useTypedSelector(state => state.userReducer.pin)
    const authenticatedUser = useTypedSelector(state => state.userReducer.authenticatedUser)
    const trackRecords = useTypedSelector(state => state.trackRecordsReducer.trackRecords)
    const tracks = useTypedSelector(state => state.tracksReducer.tracks)
    const shifts = useTypedSelector(state => state.shiftsReducer.shifts)

    return (
        <Timer
            isOffline={! isOnline}
            isUserInactive={authenticatedUser?.status === UserStatus.inActive}
            employeeNumber={employeeNumber}
            pin={pin}
            shifts={shifts}
            trackRecords={trackRecords}
            tracks={tracks}
        />
    )
}
